import _regenerator from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.every.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import fileToDataUrl from '@/utils/data-url';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, default_1, [].concat(args));
    _defineProperty(_this, "color", void 0);
    _defineProperty(_this, "dialogVisible", false);
    _defineProperty(_this, "listObj", {});
    _defineProperty(_this, "defaultFileList", []);
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "checkAllSuccess",
    value: function checkAllSuccess() {
      var _this2 = this;
      return Object.keys(this.listObj).every(function (item) {
        return _this2.listObj[item].hasSuccess;
      });
    }
  }, {
    key: "uploadFile",
    value: function uploadFile(options) {
      return {
        abort: function abort() {},
        then: function then(onSuccess, onError) {
          onSuccess({}, options.file);
        }
      };
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this3 = this;
      var arr = Object.keys(this.listObj).map(function (v) {
        return _this3.listObj[v];
      });
      this.$emit('successCBK', arr);
      this.listObj = {};
      this.defaultFileList = [];
      this.dialogVisible = false;
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(response, file) {
      var uid = file.uid;
      var objKeyArr = Object.keys(this.listObj);
      for (var i = 0, len = objKeyArr.length; i < len; i++) {
        if (this.listObj[objKeyArr[i]].uid === uid) {
          this.listObj[objKeyArr[i]].url = response.files.file;
          this.listObj[objKeyArr[i]].hasSuccess = true;
          return;
        }
      }
    }
  }, {
    key: "handleRemove",
    value: function handleRemove(file) {
      var uid = file.uid;
      var objKeyArr = Object.keys(this.listObj);
      for (var i = 0, len = objKeyArr.length; i < len; i++) {
        if (this.listObj[objKeyArr[i]].uid === uid) {
          delete this.listObj[objKeyArr[i]];
          return;
        }
      }
    }
  }, {
    key: "beforeUpload",
    value: function () {
      var _beforeUpload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(file) {
        var _this4 = this;
        var fileName, img, url;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              fileName = file.uid;
              img = new Image();
              _context.n = 1;
              return fileToDataUrl(file);
            case 1:
              url = _context.v;
              img.src = window.URL.createObjectURL(file);
              img.onload = function () {
                _this4.listObj[fileName] = {
                  hasSuccess: false,
                  uid: file.uid,
                  url: url,
                  width: img.width,
                  height: img.height
                };
              };
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      function beforeUpload(_x) {
        return _beforeUpload.apply(this, arguments);
      }
      return beforeUpload;
    }()
  }]);
}(Vue);
__decorate([Prop({
  required: true
})], default_1.prototype, "color", void 0);
default_1 = __decorate([Component({
  name: 'EditorImageUpload'
})], default_1);
export default default_1;